import React, { useCallback, useState } from "react";
import i18n from "i18n";
import ChangeFieldTypeModal from "views/logic/fieldactions/ChangeFieldType/ChangeFieldTypeModal";
import { isFunction } from "views/logic/aggregationbuilder/Series";
import isReservedField from "views/logic/IsReservedField";
import useInitialSelection from "views/logic/fieldactions/ChangeFieldType/hooks/useInitialSelection";
const ChangeFieldType = ({ field, onClose }) => {
  const [show, setShow] = useState(true);
  const handleOnClose = useCallback(() => {
    setShow(false);
    onClose();
  }, [onClose]);
  const { list, isLoading } = useInitialSelection();
  return /* @__PURE__ */ React.createElement(
    ChangeFieldTypeModal,
    {
      initialSelectedIndexSets: list,
      onClose: handleOnClose,
      initialData: { fieldName: field },
      show,
      isLoading
    }
  );
};
const hasMappingPermission = ({ isPermitted }) => !!(isPermitted == null ? void 0 : isPermitted("typemappings:edit"));
export const isChangeFieldTypeEnabled = ({ field, type, contexts }) => !isFunction(field) && !type.isDecorated() && !isReservedField(field) && hasMappingPermission(contexts);
export const ChangeFieldTypeHelp = ({ contexts }) => {
  if (hasMappingPermission(contexts)) return null;
  return {
    title: i18n.t("change_field_type.no_permission_title", { ns: "search" }),
    description: i18n.t("change_field_type.no_permission_description", { ns: "search" })
  };
};
export default ChangeFieldType;
